import { prop,propObject,propArray,required,maxLength,range  } from "@rxweb/reactive-form-validators"
import { gridColumn } from "@rxweb/grid"


export class CompanySizeLookupBase {

//#region companySizeId Prop
        @gridColumn({visible: true, columnIndex:0, allowSorting: true, headerKey: 'companySizeId', keyColumn: true})
        companySizeId : number;
//#endregion companySizeId Prop


//#region companySize Prop
        @gridColumn({visible: true, columnIndex:1, allowSorting: true, headerKey: 'companySize', keyColumn: false})
        companySize : string;
//#endregion companySize Prop

}